import { useDeleteTenant } from '@hakimo-ui/hakimo/data-access';
import { BasicPanel } from '@hakimo-ui/hakimo/ui-elements';
import { toast } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteTenantModal } from './DeleteTenantModal';

interface Props {
  tenantId: string;
  tenantName: string;
}

export function DeleteTenantCard(props: Props) {
  const { tenantId, tenantName } = props;
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const onDeleteSuccess = () => {
    toast('Tenant deactivated successfully', { type: 'success' });
    setShowModal(false);
    navigate('/tenants-admin');
  };

  const onDeleteError = (error: Error) => {
    toast(error.message || 'Failed to delete tenant', { type: 'error' });
  };

  const deleteMutation = useDeleteTenant(
    tenantId,
    onDeleteSuccess,
    onDeleteError
  );

  const handleDelete = () => {
    setShowModal(true);
  };

  const handleConfirmDelete = () => {
    deleteMutation.mutate();
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <BasicPanel title="Delete">
        <div className="px-6 pb-6">
          <p className="text-onlight-text-2 dark:text-ondark-text-2 mb-4 text-sm">
            No longer want to use this Tenant for monitoring? You can delete the
            Tenant here.
          </p>
          <Button variant="error" onClick={handleDelete}>
            Delete {tenantName}
          </Button>
        </div>
      </BasicPanel>

      <DeleteTenantModal
        open={showModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        isDeleting={deleteMutation.isLoading}
        tenantName={tenantName}
      />
    </>
  );
}

export default DeleteTenantCard;
